import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import cashSessionService from '../../services/cashSessionService';

const CashMovementForm = ({ show, onClose, onSubmit, sessionId, type }) => {
  const [formData, setFormData] = useState({
    monto: '',
    concepto: '',
    descripcion: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isRetiro = type === 'retiro';
  const title = isRetiro ? 'Registrar Retiro' : 'Registrar Ingreso';
  const icon = isRetiro ? 'arrow-down-circle' : 'arrow-up-circle';
  const variant = isRetiro ? 'danger' : 'success';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.monto || parseFloat(formData.monto) <= 0) {
      setError('El monto debe ser mayor a 0');
      return;
    }

    if (!formData.concepto.trim()) {
      setError('Debes ingresar un concepto');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const data = {
        monto: parseFloat(formData.monto),
        concepto: formData.concepto,
        descripcion: formData.descripcion,
      };

      const service = isRetiro 
        ? cashSessionService.registerWithdrawal
        : cashSessionService.registerIncome;

      const response = await service(sessionId, data);

      if (response.success) {
        onSubmit();
      } else {
        setError(response.message || 'Error al registrar el movimiento');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error al registrar el movimiento');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={`bi bi-${icon} me-2`}></i>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Monto <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="monto"
              value={formData.monto}
              onChange={handleChange}
              placeholder="0.00"
              required
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Concepto <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="concepto"
              value={formData.concepto}
              onChange={handleChange}
              placeholder={isRetiro ? 'Ej: Depósito bancario' : 'Ej: Fondo adicional'}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Descripción (Opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Detalles adicionales..."
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant={variant} type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Registrando...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Registrar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CashMovementForm;